const MAIN_BREAKPOINT = 1024;

const mediaqueries = {
  mobile: `(max-width: ${MAIN_BREAKPOINT - 1}px)`,
  desktop: `(min-width: ${MAIN_BREAKPOINT}px)`,
  mobileAnimation: `(max-width: ${MAIN_BREAKPOINT - 1}px) and (prefers-reduced-motion: no-preference)`,
  desktopAnimation: `(min-width: ${MAIN_BREAKPOINT}px) and (prefers-reduced-motion: no-preference)`,
};

export const getMediaqueryDual = (mq: keyof typeof mediaqueries) => {
  return mediaqueries[mq];
};

export const uid = () => String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
